<template>
    <div>
        <div class="page-header">
            <h1 class="page-header-title">
                <slot></slot>
            </h1>

            <div class="page-header-actions">
                <slot name="actions"></slot>
            </div>
        </div>
    </div>
</template>
<style>
.page-header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.page-header-title {
    font-size: 1.375rem;
    margin: 0;
    line-height: 75px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(--ct-page-title-color);
}
</style>
>
